// extracted by mini-css-extract-plugin
export default {"footer":"styles_footer__tbGPT","copy":"styles_copy__tvIm+","legalBlock":"styles_legalBlock__-niW8"};